module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre1",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_vm._m(0), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v(" "), _c('big', {
    staticClass: "calibre4"
  }, [_vm._v("BIGLOW PAPERS.")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    staticClass: "calibre6",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_vm._v("JAMES RUSSELL LOWELL.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('big', {
    staticClass: "calibre4"
  }, [_vm._v("Newly Edited,")]), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre7"
  }), _vm._v("\n  WITH A PREFACE"), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BY THE")]), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('big', {
    staticClass: "calibre4"
  }, [_vm._v("AUTHOR OF \""), _c('i', {
    staticClass: "calibre8"
  }, [_vm._v("TOM BROWN'S SCHOOL-DAYS")]), _vm._v(".\"")])], 1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "head"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "calibre9"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1",
    attrs: {
      "id": "Page_v",
      "title": "[Pg v]"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6b4f454","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section0001.vue
// module id = 57
// module chunks = 0